import EventEmitter from './EventEmitter.js'

export default class Sizes extends EventEmitter
{
    constructor()
    {
        super()

        this.width = window.innerWidth
        this.height = window.innerHeight
        this.pixelRatio = Math.min(window.devicePixelRatio, 2)

        this.widthState = 0
        this.device = {}
        this.device["Desktop"] = 1920
        this.device["Mobile"] = 768

        window.addEventListener('resize', () => {this.resize()})
        
        this.checkWidthState()
    }

    checkWidthState()
    {
        if (this.width <= this.device["Mobile"]) this.widthState = 1
        else if (this.width <= this.device["Desktop"]) this.widthState = 0
    }

    resize()
    {
        this.width = window.innerWidth
        this.height = window.innerHeight
        this.pixelRatio = Math.min(window.devicePixelRatio, 2)

        this.checkWidthState()

        this.trigger('resize')
    }
}